import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const usePDFViewerStyles = makeStyles((theme: Theme) => ({
  actionsDarkTheme: {
    background: 'var(--background-color-black-pastel)',
    paddingBottom: theme.spacing(1.5),
    width: '100%',
  },
  actionsDarkThemePaddingTop: {
    padding: theme.spacing(1.5, 0),
  },
  pageNumberFullScreen: {
    color: 'white',
  },
  viewerRounded: {
    borderRadius: theme.spacing(0.5),
  },
  viewerWithBorder: {
    border: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  previewDialog: {
    /**
     * We use this max height to:
     * - Force the dialog title, dialog actions and PDF viewer actions
     *   to fit inside the viewport
     * - Force the PDF viewer to scroll if it overflows
     *
     * @note the spacing must match the height of:
     * dialog title + dialog actions + PDF viewer action
     */
    maxHeight: `calc(100vh - ${theme.spacing(40)})`,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
}));

export default usePDFViewerStyles;
